const LangSignUp = {
	"signUp.form._createAccount": ["CREATE AN ACCOUNT", "TẠO TÀI KHOẢN"],
	"signUp.form._createAccount2": ["Create an Account", "Tạo tài khoản mới"],
	"signUp.form._passwordRules": [
		"Password must:<br />The length is 8-15 characters. It contains at least 1 uppercase letter, 1 lowercase letter, 1 numeric character and 1 special characters.",
		"Mật khẩu phải:<br />Dài 8-15 ký tự, bao gồm ít nhất 1 chữ in hoa, 1 chữ in thường, 1 số và 1 ký tự đặc biệt.",
	],
	"signUp.form._consentAgreementRules": [
		"By clicking this button, I agree to the Starbucks Site&nbsp;",
		"Bằng cách bấm nút bên dưới, tôi đã đọc và đồng ý với Starbucks&nbsp;",
	],
	"signUp.form._termOfUse": ["Terms & Conditions", "Điều kiện điều khoản"],
	"signUp.form._termOfUseLink": [
		"https://en.starbucks.vn/about-us/company-information/online-policies/starbucks-rewards-terms-and-conditions",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/starbucks-rewards-terms-and-conditions",
	],
	"signUp.form._consentAgreementRules2": ["&nbsp;", "&nbsp;chương trình"],
	"signUp.form.label._consentAgreement": [
		"I do not wish to receive news, special offers and more from Starbucks.",
		"Không đồng ý nhận email khuyến mãi từ chương trình.",
	],
	"signUp.form.name._consentAgreement": ["Consent Agreement", "vi_Consent Agreement"],
	"signUp.form._Whatisthis": ["What is this?", "vi_What is this?"],
	"signUp.form._Scratch": [
		"Scratch off this portion at the back of your card",
		"Vui lòng nhập dãy số dưới lớp cào",
	],
	"signUp._haveCard._decription": [
		"Upon completing your registration, you will receive a digital Starbucks Card that can be used to make payment at the stores or pay for mobile orders via our app.",
		"Sau khi hoàn thành việc đăng ký tài khoản, bạn sẽ nhận được một Thẻ Starbucks điện tử trong tài khoản, thẻ này có thể được sử dụng để thanh toán tại cửa hàng hoặc đặt đơn qua ứng dụng.",
	],
	"sign._haveCard._title": [
		"Already have a Starbucks Card?",
		"Bạn đã có Thẻ Starbucks?",
	],
	"signUp.form._switch._title": [
		"Already have a Starbucks Card?",
		"Bạn đã có Thẻ Starbucks?",
	],
	"signUp.form._switch._decription": [
		"Upon completing your registration, you will receive a digital Starbucks Card that can be used to make payment at the stores or on Mobile Order & Pay via our mobile app.",
		"Sau khi hoàn thành việc đăng ký tài khoản, bạn sẽ nhận được một Thẻ Starbucks điện tử trong tài khoản, thẻ này có thể được sử dụng để thanh toán tại cửa hàng hoặc đặt đơn qua ứng dụng.",
	],
	"signUp.form._success": [
		" A verification link has been sent to your email, please check your email to verify",
		"Một đường dẫn kích hoạt đã được gửi đến email của bạn, vui lòng kiểm tra email để kích hoạt tài khoản",
	],
}

export default LangSignUp



// WEBPACK FOOTER //
// ./src/resources/pages/LangSignUp.js